'use strict';

import Cookies from 'universal-cookie';

const COUNT_KEY = 'sb_prog_n';
const CHUNK_KEY = (i) => `sb_pg_${i}`;
const MAX_AGE_SEC = 60 * 60 * 24 * 14; // 14 days
/** ~3.5k per chunk — stay under per-cookie browser limits */
const CHUNK_SIZE = 3500;

function cookieOpts() {
	return {
		path: '/',
		maxAge: MAX_AGE_SEC,
		sameSite: 'lax',
		secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
	};
}

function getCookies() {
	return new Cookies();
}

function clearChunkCookies(db) {
	const nRaw = db.get(COUNT_KEY);
	const n = parseInt(String(nRaw), 10);
	db.remove(COUNT_KEY, { path: '/' });
	if (Number.isFinite(n) && n > 0) {
		for (let i = 0; i < n; i++) {
			db.remove(CHUNK_KEY(i), { path: '/' });
		}
	}
}

/**
 * @param {Record<string, unknown>} obj
 */
export function writeProgressToCookies(obj) {
	try {
		const db = getCookies();
		clearChunkCookies(db);
		const encoded = encodeURIComponent(JSON.stringify(obj));
		const chunks = [];
		for (let i = 0; i < encoded.length; i += CHUNK_SIZE) {
			chunks.push(encoded.slice(i, i + CHUNK_SIZE));
		}
		if (chunks.length === 0) return;
		db.set(COUNT_KEY, String(chunks.length), cookieOpts());
		chunks.forEach((c, i) => {
			db.set(CHUNK_KEY(i), c, cookieOpts());
		});
	} catch {
		// ignore quota / oversized
	}
}

/** @returns {Record<string, unknown>|null} */
export function readProgressFromCookies() {
	try {
		const db = getCookies();
		const n = parseInt(String(db.get(COUNT_KEY)), 10);
		if (!Number.isFinite(n) || n < 1) return null;
		let encoded = '';
		for (let i = 0; i < n; i++) {
			const part = db.get(CHUNK_KEY(i));
			if (typeof part !== 'string') return null;
			encoded += part;
		}
		const o = JSON.parse(decodeURIComponent(encoded));
		return o && typeof o === 'object' ? o : null;
	} catch {
		return null;
	}
}

export function clearProgressCookies() {
	try {
		const db = getCookies();
		clearChunkCookies(db);
	} catch {
		// ignore
	}
}
